import './app/reset.css'
import './app/styles.css'
import './App.css'
import '@fontsource/poppins'
import { createTheme, responsiveFontSizes } from '@mui/material/styles'
import 'react-dropzone-uploader/dist/styles.css'
import 'video-react/dist/video-react.css'

let theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: `'Poppins', sans-serif`,
    },
  },
  palette: {
    primary: {
      main: '#F9B22D',
    },
    secondary: {
      main: '#352E73',
    },
  },
  components: {
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          body2: 'span',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: '20px',
          transform: 'translate(24px, 22px) scale(1)',
        },
        shrink: {
          fontSize: '16px',
          transform: 'translate(24px, -11px) scale(1)',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '100px',
          padding: '11px',
        },
        input: {
          fontSize: '20px',
          padding: '10px 16px',
        },
        inputAdornedStart: {
          padding: '10px 16px 10px 61px',
          marginLeft: '-3px',
        },
        notchedOutline: {
          padding: '0 18px',
          legend: {
            fontSize: '16px',
            backgroundColor: 'white',
            visibility: 'initial',
            span: {
              visibility: 'hidden',
            },
          },
        },
      },
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          width: 0,
          left: '18px',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: '20px',
          borderRadius: '100px',
          color: 'white',
          textTransform: 'initial',
          boxShadow: '0px 4px 30px 0px #A1A1A140',
          border: '2px solid white',
          padding: '8px 20px',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
  },
})

theme.typography.h1 = {
  fontFamily: `'Poppins', sans-serif`,
  fontWeight: 600,
  fontSize: 38,
  lineHeight: 36 / 26,
  color: '#000066',
}

theme.typography.h3 = {
  fontFamily: `'Poppins', sans-serif`,
  fontWeight: 400,
  fontSize: 22,
  lineHeight: 36 / 26,
  color: '#F9B22D',
}

theme.typography.subtitle1 = {
  fontFamily: `'Poppins', sans-serif`,
  fontSize: 22,
  lineHeight: 36 / 26,
  fontWeight: 300,
  color: '#6A707E',
}

theme = responsiveFontSizes(theme)

export default theme
